import apiClient from "../../../api/apiClient";

const BASE_PATH = "/admin/users";

export const authLogin = async (email, password) => {
  const response = await apiClient.post(`${BASE_PATH}/login`, {
    email,
    password,
  });
  return response.data;
};
